<template>
  <div class="login-bg">
    <div class="language-picker">
      <el-select v-model="selectedLanguage" size="small" @change="change_language">
        <el-option
          v-for="language in supportedLanguages"
          :key="language.code"
          :label="language.label"
          :value="language.code">
        </el-option>
      </el-select>
    </div>
    <main class="login-card" v-loading="loading">
      <img src="../assets/logo2.png" class="img-logo" />

      <div class="header">
        <h1>{{ $t("login.marketplace_title") }}</h1>
        <p>{{ $t("login.microsoft_subtitle") }}</p>
      </div>

      <el-alert
        v-if="ssoError"
        :title="ssoError"
        type="error"
        show-icon
        class="sso-alert"
        :closable="false">
      </el-alert>

      <button type="button" class="sso-button" :disabled="!ssoEnabled" @click="start_sso">
        <span class="ms-icon" aria-hidden="true">
          <i></i><i></i><i></i><i></i>
        </span>
        <span>{{ $t("login.microsoft_button") }}</span>
      </button>

      <el-alert
        v-if="ssoChecked && !ssoEnabled"
        :title="$t('login.sso_unavailable')"
        type="warning"
        show-icon
        class="sso-alert"
        :closable="false">
      </el-alert>

      <p class="access-note">
        {{ $t("login.no_access") }}
        <a :href="'mailto:' + contactEmail">{{ $t("login.request_access") }}</a>
      </p>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import settings from "./../backend/LocalSettings";
import { SUPPORTED_LANGUAGES, normalizeLanguage } from "./../utils/languages";

export default {
  name: "login",
  data () {
    return {
      supportedLanguages: SUPPORTED_LANGUAGES,
      selectedLanguage: normalizeLanguage(window.localStorage.getItem("locale") || "en"),
      loading: false,
      ssoEnabled: false,
      ssoChecked: false,
      ssoLoginUrl: "",
      ssoError: "",
      contactEmail: "b.haukova@salesianer.com"
    }
  },
  methods: {
    change_language: function(language) {
      var locale = normalizeLanguage(language);
      this.selectedLanguage = locale;
      window.localStorage.setItem("locale", locale);
      Vue.http.headers.common["Language"] = locale;
      this.$i18n.locale = locale;
    },
    load_sso_status: function() {
      this.$http
        .post("auth/status", {})
        .then(function(response) {
          this.ssoEnabled = response.body.Enabled && response.body.Configured;
          this.ssoLoginUrl = response.body.LoginUrl;
          this.contactEmail = response.body.ContactEmail || this.contactEmail;
          this.ssoChecked = true;
        }, function() {
          this.ssoChecked = true;
        });
    },
    start_sso: function() {
      if (!this.ssoLoginUrl) {
        this.$message.error(this.$t("login.sso_not_configured"));
        return;
      }
      window.location.href = this.ssoLoginUrl;
    },
    check_login() {
      if( settings.is_logged_in() ){
        this.$router.push("/dashboard");
      }
    }
  },
  mounted: function() {
    this.change_language(this.selectedLanguage);
    this.ssoError = this.$route.query.sso_error || "";
    this.check_login();
    this.load_sso_status();
  }
};
</script>

<style lang="less" scoped>
  .login-bg {
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px;
    background:
      linear-gradient(180deg, rgba(8, 12, 28, 0.08), rgba(8, 12, 28, 0.25)),
      url("../assets/login-bg.jpg");
    background-position: center;
    background-size: cover;
  }

  .language-picker {
    position: absolute;
    top: 18px;
    right: 18px;
    width: 160px;
    z-index: 2;
  }

  .login-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 440px;
    max-width: 100%;
    padding: 42px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 26px 76px rgba(8, 12, 28, 0.3);
  }

  .img-logo {
    width: 288px;
    max-width: 100%;
  }

  .header {
    margin: 30px 0 26px;
    text-align: center;
  }

  .header h1 {
    margin: 0;
    font-size: 32px;
    line-height: 1.1;
    font-weight: 700;
    color: #202631;
  }

  .header p {
    margin: 14px 0 0;
    color: #5e6f89;
    font-size: 16px;
  }

  .sso-alert {
    width: 100%;
    margin-bottom: 18px;
  }

  .sso-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    min-height: 52px;
    border: 0;
    border-radius: 6px;
    background: #2d72c5;
    color: white;
    box-shadow: 0 12px 24px rgba(45, 114, 197, 0.24);
    font-size: 17px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  }

  .sso-button:hover {
    transform: translateY(-1px);
    background: #1e64b6;
    box-shadow: 0 16px 30px rgba(45, 114, 197, 0.3);
  }

  .sso-button:active {
    transform: translateY(0);
  }

  .sso-button:disabled {
    transform: none;
    background: #9aa9bb;
    box-shadow: none;
    cursor: not-allowed;
  }

  .ms-icon {
    display: grid;
    grid-template-columns: repeat(2, 10px);
    grid-template-rows: repeat(2, 10px);
    gap: 2px;
  }

  .ms-icon i:nth-child(1) { background: #f25022; }
  .ms-icon i:nth-child(2) { background: #7fba00; }
  .ms-icon i:nth-child(3) { background: #00a4ef; }
  .ms-icon i:nth-child(4) { background: #ffb900; }

  .access-note {
    margin: 18px 0 0;
    color: #65758a;
    font-size: 14px;
    text-align: center;
  }

  .access-note a {
    color: #2d72c5;
    font-weight: 700;
    text-decoration: none;
  }

  @media only screen and (max-width: 768px) {
    .login-bg {
      align-items: flex-start;
      padding: 18px;
      padding-top: 76px;
    }

    .language-picker {
      left: 18px;
      right: 18px;
      width: auto;
    }

    .login-card {
      padding: 32px 26px;
    }

    .header h1 {
      font-size: 34px;
    }
  }
</style>
